module.exports = "https://health.dajiuxing.com.cn/img/assets/serviceImg/ylsf1.png"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=assets%2FserviceImg%2Fylsf1.png
// module id = t7rp
// module chunks = 93